import type { RestrictivePracticeStatus, RestrictivePracticeType } from '@piccolohealth/pbs-common';
import React from 'react';

const DEFAULT_DESCRIPTION_FILTER: string | undefined = '';
const DEFAULT_TYPE_FILTER: RestrictivePracticeType[] = [];
const DEFAULT_STATUS_FILTER: RestrictivePracticeStatus[] = [];

export interface ParticipantRestrictivePracticesFilter {
  descriptionFilter: string;
  typeFilter: RestrictivePracticeType[];
  statusFilter: RestrictivePracticeStatus[];
  activeFilterCount: number;
  onDescriptionFilter: (description: string) => void;
  onTypeFilter: (types: RestrictivePracticeType[]) => void;
  onStatusFilter: (statuses: RestrictivePracticeStatus[]) => void;
  reset: () => void;
}

export const useParticipantRestrictivePracticesFilter =
  (): ParticipantRestrictivePracticesFilter => {
    const [params, setParams] = React.useState({
      description: DEFAULT_DESCRIPTION_FILTER,
      type: DEFAULT_TYPE_FILTER,
      status: DEFAULT_STATUS_FILTER,
    });

    const onDescriptionFilter = (value: string) =>
      setParams((prev) => ({
        ...prev,
        description: value,
      }));

    const onTypeFilter = (value: RestrictivePracticeType[]) =>
      setParams((prev) => ({
        ...prev,
        type: value,
      }));

    const onStatusFilter = (value: RestrictivePracticeStatus[]) =>
      setParams((prev) => ({
        ...prev,
        status: value,
      }));

    const reset = () =>
      setParams({
        description: DEFAULT_DESCRIPTION_FILTER,
        type: DEFAULT_TYPE_FILTER,
        status: DEFAULT_STATUS_FILTER,
      });

    const activeFilterCount = [params.description.length > 0, params.type.length > 0].filter(
      Boolean,
    ).length;

    return {
      descriptionFilter: params.description,
      typeFilter: params.type,
      statusFilter: params.status,
      activeFilterCount,
      onDescriptionFilter,
      onTypeFilter,
      onStatusFilter,
      reset,
    };
  };
